<template>
    <cl-form :model="datas" :fields="fields" :urlSubmit="urlSubmit" :beforSubmit="beforSubmit" :submitType="submitType" class="pz_manger mform"
             :pageload="pageload" :btnDoReset="addOrEdit" :oprah="oprah">
        <cl-form-row>
            <el-input ref="name" slot="name" v-model="datas.name" placeholder="请输入餐饮名称"></el-input>
        </cl-form-row>
        <cl-form-row>
            <el-select ref="type" slot="type" v-model="datas.type" clearable placeholder="请选择餐饮类型">
                <el-option v-for="item in typeList" :key="item.value" :label="item.name" :value="item.name"></el-option>
            </el-select>
            <el-select ref="businessDistrict" slot="businessDistrict" v-model="datas.businessDistrict" clearable placeholder="请选择所在商圈">
                <el-option v-for="item in businessDistrictList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
        </cl-form-row>
        <cl-form-row>
            <div ref="areaName" slot="areaName" class="jq-areaName">
                <cl-select v-model="datas.areaName[0]" placeholder="省" size="mini" @change="proviceChange">
                    <el-option
                            v-for="item in proviceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </cl-select>
                <cl-select v-model="datas.areaName[1]" placeholder="市" size="mini" @change="proviceChange"
                           class="selectHeight">
                    <el-option
                            v-for="item in cityList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </cl-select>
                <cl-select v-model="datas.areaName[2]" placeholder="县(区)" size="mini" @change="proviceChange">
                    <el-option
                            v-for="item in countyList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </cl-select>
            </div>
        </cl-form-row>
        <cl-form-row>
            <ClInputNumber
                    :min="0"
                    :max="500"
                    :precision="2"
                    ref="perPrice"
                    slot="perPrice"
                    v-model="datas.perPrice"
                    placeholder="请输入价格">
            </ClInputNumber>
        </cl-form-row>
        <cl-form-row>
            <el-input ref="address" slot="address" v-model="datas.address" placeholder="请输入地址"></el-input>
            <el-input ref="tel" slot="tel" v-model="datas.tel" placeholder="请输入联系电话"></el-input>
        </cl-form-row>
        <cl-form-row>
            <el-input ref="longitude" slot="longitude" v-model="datas.longitude" placeholder="请输入经度"></el-input>
            <el-input ref="latitude" slot="latitude" v-model="datas.latitude" placeholder="请输入纬度"></el-input>
        </cl-form-row>
        <cl-form-row>
            <el-select ref="label" slot="label" v-model="datas.label"  :multiple="true"  placeholder="请选择美食标签">
                <el-option v-for="item in labelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
        </cl-form-row>
        <cl-form-row>
            <el-input-number ref="score" slot="score" :precision="2" :min="0" :max="5" v-model="datas.score" ></el-input-number>
            <el-input-number ref="park" slot="park" :precision="2" :min="0" :max="5" v-model="datas.park" ></el-input-number>
        </cl-form-row>
        <cl-form-row>
            <el-input ref="photos" slot="photos" v-model="datas.photos" readonly="true" type="textarea" :rows="3"></el-input>
        </cl-form-row>
        <cl-form-row>
            <el-input ref="summary" slot="summary" v-model="datas.summary" type="textarea" :rows="5"
                      placeholder="请输入简介，长度不超过512个字符"></el-input>
        </cl-form-row>
        <cl-form-row>
            <el-input ref="gdTags" slot="gdTags" v-model="datas.gdTags" type="textarea" :rows="5"
                      placeholder="请输入标签，标签之间用逗号隔开"></el-input>
        </cl-form-row>
        <cl-form-row>
            <ClUeditor ref="content" slot="content" :UeId="openType" :config={topOffset:110}
                       v-model="datas.content" Url="/api/zuul/wtcp-bic/uploads"></ClUeditor>
        </cl-form-row>
        <el-button  slot='customButtons' @click="btnDoAuditOkAndIssue(ths.th)" class="savepublish" type="primary" slot-scope="ths">保存并发布</el-button>
    </cl-form>
</template>

<script>
    import ElOption from "../../../../../packages/components/select/src/option";
    export default {
        name: "foodDrinkServeForm",
        components: {ElOption},
        data() {
            // 后台校验餐饮名称
            const that = this;
            const cyName = function (coder, value, callback) {
                return callback();//暂时不用名称唯一性校验，用的话删掉这个return
                if (value !== "") {
                    if (that.openType == -1) {
                        that.$http.get("/wtcp-bic/foodDrinkServe/existByName?access_token=" + that.request.getSession("userToken") + "&name=" + value
                        )
                            .then(res => {
                                if (res.status === 1) {
                                    return callback();
                                } else {
                                    callback(new Error("该名称已存在！"));
                                }
                            });
                    } else {
                        that.$http.get("/wtcp-bic/foodDrinkServe/existByName?access_token=" + that.request.getSession("userToken") + "&name=" + value + "&id=" + that.openType
                        )
                            .then(res => {
                                if (res.status === 1) {
                                    return callback();
                                } else {
                                    callback(new Error("该名称已存在！"));
                                }
                            });
                    }
                }
            };
            const areaNameRule = (rule, value, callback) => {
                if (value) {
                    if (value.length < 2) {
                        callback(new Error("请至少选择到市级"));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            return {

                ths:{},
                openType: "",
                oprah:{},
                pageload: true,
                required: true,
                elOption: [],
                fields: {
                    row1: [
                        {
                            name: "name",
                            label: "餐饮名称",
                            span: 24,
                            rules: [
                                {
                                    required: true,
                                    message: "餐饮名称不能为空",
                                    trigger: "blur"
                                },
                                {
                                    min: 2,
                                    max: 30,
                                    message: "输入的字符长度在2-30之间"
                                },
                                {
                                    pattern: this.regex.illcharacter,
                                    message: "不能含有非法字符",
                                    trigger: "blur"
                                },
                                {
                                    validator: cyName,
                                    trigger: "blur"
                                }
                            ]
                        }
                    ],
                    row2: [
                        {
                            name: "type",
                            label: "餐饮类型",
                            span: 12,
                            rules: [
                                {
                                    required: false,
                                    message: "请选择餐饮类型",
                                    trigger: "blur"
                                },
                            ]
                        },
                        {
                            name: "businessDistrict",
                            label: "所在商圈",
                            span: 12,
                            rules: [
                                {
                                    required: false,
                                    message: "请选择所在商圈",
                                    trigger: "blur"
                                },
                            ]
                        }
                    ],
                    row3: [
                        {
                            name: 'areaName',
                            label: '所在地区',
                            span: 12,
                            rules: [
                                {
                                    required: true,
                                    message: "所在地区不能为空",
                                    trigger: "blur"
                                },
                                {

                                    type: "array",
                                    validator: areaNameRule,
                                    trigger: "change"
                                },
                            ]
                        },
                    ],
                    row4: [
                        {
                            name: 'perPrice',
                            label: '人均消费（元）',
                            span: 12,
                        },
                    ],
                    row5: [
                        {
                            name: "address",
                            label: "地址",
                            span: 12,
                            rules: [
                                {
                                    required: true,
                                    message: "地址不能为空",
                                    trigger: "blur"
                                },
                                {
                                    min: 2,
                                    max: 64,
                                    message: "输入的字符长度在2-64之间"
                                },
                                {
                                    pattern: this.regex.illcharacter,
                                    message: "不能含有非法字符",
                                    trigger: "blur"
                                },
                            ]
                        },
                        {
                            name: "tel",
                            label: "联系电话",
                            span: 12,
                            rules: [
                                {
                                    required: true,
                                    message: "联系电话不能为空",
                                    trigger: "blur"
                                },
                                {
                                    min: 2,
                                    max: 100,
                                    message: "输入的字符长度在2-13之间"
                                },
                                {
                                    type: "string",
                                    pattern: this.regex.TelAndMobile,
                                    message: "请输入正确的联系电话",
                                    trigger: "blur"
                                }
                            ]
                        }
                    ],
                    row6: [
                        {
                            name: "longitude",
                            label: "经度",
                            span: 12,
                            rules: [
                                {
                                    required: true,
                                    message: "经度不能为空",
                                    trigger: "blur"
                                },
                                {
                                    type: "string",
                                    pattern: this.regex.longitude,
                                    message: "经度范围(整数部分:为-180～180，小数点后最多8位)",
                                    trigger: "blur"
                                }
                            ]
                        },
                        {
                            name: "latitude",
                            label: "纬度",
                            span: 12,
                            rules: [
                                {
                                    required: true,
                                    message: "纬度不能为空",
                                    trigger: "blur"
                                },
                                {
                                    type: "string",
                                    pattern: this.regex.latitude,
                                    message: "纬度范围(整数部分:为-90～90，小数点后最多8位)",
                                    trigger: "blur"
                                }
                            ]
                        }
                    ],
                    row7: [
                        {
                            name: "label",
                            label: "美食标签",
                            span: 24,
                        }
                    ],
                    row8: [
                        {
                            name: "score",
                            label: "餐饮评分",
                            span: 12,
                            rules: [
                                {
                                    type: "number",
                                    min: 0,
                                    max: 5,
                                    message: "允许的范围为0-5",
                                    trigger: "blur"
                                },
                                {
                                    type: "number",
                                    min: 0,
                                    max: 5,
                                    message: "允许的范围为0-5",
                                    trigger: "change"
                                }
                            ]
                        },
                        {
                            name: "park",
                            label: "停车方便评分",
                            span: 12,
                            rules: [
                                {
                                    type: "number",
                                    min: 0,
                                    max: 5,
                                    message: "允许的范围为0-5",
                                    trigger: "blur"
                                },
                                {
                                    type: "number",
                                    min: 0,
                                    max: 5,
                                    message: "允许的范围为0-5",
                                    trigger: "change"
                                }
                            ]
                        }
                    ],
                    row9: [
                        {
                            name: "photos",
                            label: "图片",
                            span: 24,
                        }
                    ],
                    row10: [
                        {
                            name: "summary",
                            label: "餐饮简介",
                            span: 24,
                            rules: [
                                {
                                    required: true,
                                    message: "请输入餐饮简介",
                                    trigger: "blur"
                                },
                                {
                                    min: 2,
                                    max: 512,
                                    message: "输入的字符长度在2-512之间"
                                },
                                {
                                    pattern: this.regex.illcharacter,
                                    message: "不能含有非法字符",
                                    trigger: "blur"
                                }
                            ]
                        }
                    ],
                    row11: [
                        {
                            name: "gdTags",
                            label: "检索标签",
                            span: 24,
                            rules: [
                                {
                                    max: 1024,
                                    message: "超过输入的字符最大长度"
                                },
                                {
                                    pattern: this.regex.illcharacter,
                                    message: "不能含有非法字符",
                                    trigger: "blur"
                                }
                            ]
                        }
                    ],
                    row12: [
                        {
                            name: 'content',
                            label: '餐饮内容',
                            rules: [{
                                required: true, message: '请填写餐饮内容', trigger: 'change'
                            }]
                        }
                    ]
                },
                datas: {
                    areaCode:"",
                    areaName: [],
                    pname:"",
                    cityname:"",
                    adname:"",
                    name: "",
                    longitude: "",
                    latitude: "",
                    address: "",
                    tel: "",
                    type: "",
                    label: [],
                    score: "",
                    businessDistrict: "",
                    park: "",
                    summary: "",
                    content: "",
                    gdTags:"",
                    photos:"",
                },
                typeList: [], //餐饮类型
                businessDistrictList: [], //所在商圈
                labelList: [],//美食标签
                //所在地区参数
                proviceList: [],//区域列表
                cityList: [],//市级列表
                countyList: [],//县(区)
            }
        },
        methods: {
            //新增、修改、重置
            addOrEdit() {
                const _this = this
                if (this.openType != -1) {
                    this.required = false;
                    this.request.getId("/wtcp-bic/foodDrinkServe", this.openType).then(res => {
                        if (res.status === 1) {
                            let _data = res.data
                            _data = _this.request.UnifiedData(_data)
                            if(_data){
                                _this.datas = _this.request.Assignment(_data, _this.datas)

                            }
                            if(_data){
                                _this.datas = _this.request.Assignment(_data, _this.datas)
                                if (typeof(_data.areaName) == "undefined" || _data.areaName == '' || _data.areaName == null) {
                                    _this.datas.areaName = [];
                                } else {
                                    _this.datas.areaName = _data.areaName.split(',');
                                }
                            }
                            if(res.data.label!=""){
                                _this.datas.label=res.data.label.split(",")
                            }else{
                                _this.datas.label=[];
                            }
                        }
                    });
                }
            },
            beforSubmit(e) {
                if(this.datas.label.length>0){
                    e.label= this.datas.label.join(",");
                }else{
                    e.label="";
                }
                e.pname=this.datas.areaName[0];
                e.cityname=this.datas.areaName[1];
                e.adname=this.datas.areaName[2];
                e.areaName=this.datas.areaName.join(",");
                e.loc=[];
                e.gdTags=this.datas.gdTags.replace(/，/g,',');
            },
            snacksList(){
                var _this = this;
                _this.request
                    .get("/wtcp-bic/specialSnacks/findByState/1")
                    .then((res) => {
                        _this.labelList = res.data
                    })
            },
            mbusinessDistrictList(){
                var _this = this;
                _this.request
                    .get("/wtcp-bic/businessDistrict/findAll")
                    .then((res) => {
                        _this.businessDistrictList = res.data
                    })
            },
            mfoodDrinkTypeList(){
                var _this = this;
                _this.request
                    .get("/wtcp-bic/foodDrinkType/findAll")
                    .then((res) => {
                        _this.typeList = res.data
                    })
            },
            //区域选中
            proviceChange(e) {
                var _this = this
                _this.request
                    .get("/wtcp-bic/public/area/ayscAreaList/" + e.value)
                    .then((res) => {
                        if (e.value.length == 2) {//省
                            _this.cityList = res.data
                            _this.countyList = []
                            _this.datas.areaName[0] = e.label
                            _this.datas.areaName = _this.datas.areaName.slice(0, 1)
                        } else if (e.value.length == 4) {//市
                            _this.countyList = res.data
                            _this.datas.areaName[1] = e.label
                            _this.datas.areaName = _this.datas.areaName.slice(0, 2)
                        } else if (e.value.length == 6) {//县
                            _this.datas.areaName[2] = e.label
                        }
                        _this.datas.areaCode = e.value
                    })
            },
            proviceCode() {
                var _this = this
                _this.request
                    .get("/wtcp-bic/public/area/ayscAreaList/0")
                    .then((res) => {
                        _this.proviceList = res.data
                    })
                if (_this.areaCode!=undefined&&_this.areaCode.length == 2) {
                    _this.request
                        .get("/wtcp-bic/public/area/ayscAreaList/" + _this.areaCode)
                        .then((res) => {
                            _this.cityList = res.data
                        })
                }
                if (_this.areaCode!=undefined&&(_this.areaCode.length == 4 || _this.areaCode.length == 6)) {
                    _this.request
                        .get("/wtcp-bic/public/area/ayscAreaList/" + _this.areaCode.substr(0, 2))
                        .then((res) => {
                            _this.cityList = res.data
                        })
                    _this.request
                        .get("/wtcp-bic/public/area/ayscAreaList/" + _this.areaCode.substr(0, 4))
                        .then((res) => {
                            _this.countyList = res.data
                        })

                }
            },
            //保存并发布
            btnDoAuditOkAndIssue(e){
               e.params={action: "tgfb"};
               e.handleSubmit();
            }
        },
        computed: {
            urlSubmit() {
                return this.openType == -1
                    ? "/wtcp-bic/foodDrinkServe"
                    : "/wtcp-bic/foodDrinkServe/" + this.openType;
            },
            submitType() {
                return this.openType == -1 ? "post" : "put";
            }
        },
        created: function() {
            this.openType = this.$route.query.id ? this.$route.query.id : -1;
            this.pageload = false;
            this.addOrEdit();
            this.snacksList();
            this.mbusinessDistrictList();
            this.mfoodDrinkTypeList();
            this.proviceCode();
        }
    }
</script>
<style lang="less">
    .jq-areaName > div {
        width: 33% !important;
    }
    .jq-areaName .selectHeight{
        padding:0 1px;
    }
    .savepublish {
        background-color: #409EFF;
        border-color: #409EFF;
        color: #FFF;
    }
    .mform  .formBtnSubmit {
        margin-right: 104px !important;
        margin-left: -62px !important;
    }
    .savepublish{
        margin-left: -225px !important;
    }
</style>
